import { render, staticRenderFns } from "./BottomBtn.vue?vue&type=template&id=6f9a6546&scoped=true"
import script from "./BottomBtn.vue?vue&type=script&lang=js"
export * from "./BottomBtn.vue?vue&type=script&lang=js"
import style0 from "./BottomBtn.vue?vue&type=style&index=0&id=6f9a6546&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a6546",
  null
  
)

export default component.exports